import { render, staticRenderFns } from "./tiyouyouAddParentsBook.vue?vue&type=template&id=1c197fef&"
import script from "./tiyouyouAddParentsBook.vue?vue&type=script&lang=js&"
export * from "./tiyouyouAddParentsBook.vue?vue&type=script&lang=js&"
import style0 from "./tiyouyouAddParentsBook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports